/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { API_PATH } from "src/environments/config";

@Injectable({
  providedIn: "root",
})
export class CscdataService {
  constructor(private http: HttpClient) {}
  getCSCdata(Id?, currency?, seller?, timeZone?) {
    let params = new HttpParams();
    params = currency
      ? params.set("type", "country")
      : params.set("type", "state");
    params = Id ? params.set("id", Id) : params;
    params = seller ? params.set("seller", seller) : params;
    params = timeZone ? params.set("timezone", timeZone) : params;
    return this.http.get<any>(API_PATH.apis.server + "/getCscData", {
      params: params,
    });
  }
}
